export default {
  terms: 'Terms and Conditions',
  phone: 'Tel: 646-786-0888',
  privacy: 'Privacy Policy'
};
